import React from 'react';
import { Grid } from '@mui/material';
import OutlinedInputComponent from '../../common/widgets/outlined-input';

interface IToolsAndtechnologiesProps {
  onNameChangeCallback: (value: string) => void;
  onCommittedCallback?: (startValue: number, endValue: number) => void;
}

const ToolsAndTechnologiesFilter = ({
  onNameChangeCallback,
  onCommittedCallback
}: IToolsAndtechnologiesProps): JSX.Element => {
  return (
    <Grid
      container
      spacing={4}
      columns={50}
      sx={{ justifyContent: 'flex-start' }}
    >
      <Grid
        item
        xs={50}
        sm={25}
        lg={12}
        sx={{
          marginRight: '20px',
          '@media (max-width: 1351px)': {
            marginRight: '0px'
          }
        }}
      >
        <OutlinedInputComponent
          onChangeCallback={onNameChangeCallback}
          placeholder={'Search'}
          height={'48px'}
          width={'100%'}
          borderRadius={'8px'}
          fontSize={'16px'}
          fontWeight={'500'}
          color={'#5F6368'}
        />
      </Grid>
    </Grid>
  );
};

export default ToolsAndTechnologiesFilter;
